import React, { useEffect, useRef } from 'react';
import '../App.css';

export default function Footer() {
  const footerRef = useRef(null);

  useEffect(() => {
    const footerEl = footerRef.current;
    if (!footerEl) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            footerEl.classList.add('footer-visible');
          }
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(footerEl);
    return () => observer.disconnect();
  }, []);

  return (
    <footer ref={footerRef} className="gooutdoor-footer">
      <span>&copy; Website by Găbița</span>
    </footer>
  );
}
